import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

const TermsOfUsePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="legal-page" data-testid="terms-of-use-page">
      {/* Block this page from search engines */}
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
        <title>Terms of Use - Amatya</title>
      </Helmet>
      
      <div className="legal-container">
        <h1 className="legal-title">Terms of Use</h1>
        <p className="legal-notice">
          PLEASE READ THESE TERMS OF USE CAREFULLY. BY USING THE PLATFORM, YOU AGREE TO BE BOUND BY ALL OF THE BELOW TERMS AND CONDITIONS AND THE PRIVACY POLICY.
        </p>

        <section className="legal-section">
          <h2>1. Introduction</h2>
          <p>
            The websites (https://www.amatya.co.in/) and the mobile application on Android and iOS Platforms AMATYA (together "Platform") are owned and operated by ANS Legal and Business Services LLP, a private company incorporated in India under the Companies Act, 2013 and having its registered office at C-209, M3M Urbana, Sector 67, Gurgaon, 122101 Haryana and includes any of our affiliates, associates, assignees or successors-in-interest as determined by us at our sole discretion and without requiring any prior notice or intimation to you ("Company", "we" or "us" or "our"). Your ("you", "your" or "user") use of the Services (as defined herein) is subject to these terms and conditions ("Terms of Use").
          </p>
          <p>
            1.2. Please read these Terms of Use, along with the Privacy Policy available at [https://www.amatya.com/privacy-policy/] and all other rules and policies made available or published on the Platform as they shall govern your use of the Platform and the services provided thereunder.
          </p>
          <p>
            1.3. By using or visiting the Platform, you signify your agreement to these Terms of Use and the Privacy Policy.
          </p>
          <p>
            1.4. These Terms of Use are an electronic record as per the Information Technology Act, 2000 (as amended/re-enacted) and rules thereunder ("IT Act") and is published in accordance with the provisions of Rule 3 (1) of the Information Technology (Intermediaries Guidelines and Digital Media Ethics code) Rules, 2021, which mandates the publishing of rules and regulations, privacy policy and terms and conditions for access or usage of any application or website. This electronic record is generated by a computer system and does not require any physical or digital signature. In addition, some of the Services may be subject to additional terms and conditions specified by us from time to time; your use of such solution is subject to those additional terms and conditions, which are incorporated into these Terms of Use by reference.
          </p>
        </section>

        <section className="legal-section">
          <h2>2. Overview of the Services</h2>
          <p>
            We are, inter alia, engaged in the business of digitizing temples and other religious experiences for our users, providing astrological services and other related services ("Services").
          </p>
        </section>

        <section className="legal-section">
          <h2>3. Acceptance of Terms</h2>
          <p>
            By downloading and/or by registering or signing up for these Services, or otherwise having access to, receiving, and/or using the Platform, you acknowledge to have read, understood and consented to be governed and bound by these Terms of Use and the Privacy Policy. If you do not accept or agree to any part of these Terms of Use or the Privacy Policy, your usage of the Services will be terminated.
          </p>
        </section>

        <section className="legal-section">
          <h2>4. Access</h2>
          <p>
            4.1. Subject to these Terms of Use, we may offer to provide you with Services selected by you, solely for your own use, and not for the use or benefit of any third party. Services shall include, but not be limited to, any services we perform for you, any hardware offered by us, or any widgets that you download from the Platform. In case of any discrepancy in the Services, you must bring the same to our notice in writing, within a period of 7 (seven) days from date of performance of the Services, failing which the Services shall be deemed accepted, fulfilled and satisfactorily completed.
          </p>
          <p>
            4.2. You agree not to circumvent, disable or otherwise interfere with security-related features of the Platform or features that prevent or restrict use or copying of any restricted information.
          </p>
        </section>

        <section className="legal-section">
          <h2>5. Registration and Eligibility</h2>
          <p>
            5.1. Only persons who can form legally binding contracts under the Indian Contract Act, 1872 may access the Platform and avail our Services. Persons who are 'incompetent to contract' within the meaning of the Indian Contract Act, 1872 including without limitation, un-discharged insolvents, are not eligible to avail our Services. If you are a minor i.e., under the age of 18 (eighteen) years, you cannot register and/or avail our Services. We reserve the right to refuse to provide you with access to the Services if it is brought to our notice or if it is discovered that you are incompetent to contract. You represent and warrant to us that you are of legal age to form a binding contract and are not a person barred from availing the Services under applicable laws.
          </p>
          <p>
            5.2. You may, at your sole discretion, log into the application using your phone number ("Login Details").
          </p>
          <p>5.3. Notwithstanding anything contained herein, you shall not:</p>
          <ul>
            <li>5.3.1 provide any false personal information to us (including false/fraudulent Login Details) or create any account for anyone other than yourself without such person's explicit permission; or</li>
            <li>5.3.2 use the Login Details of another person with the intent to impersonate that person.</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>6. Your Responsibilities</h2>
          <p>6.1. By using the Platform, you represent and warrant that:</p>
          <ul>
            <li>6.1.1. you have fully read and understood the Terms of Use and Privacy Policy and consent to them;</li>
            <li>6.1.2. you will ensure that your use of the Platform and/or Services will not violate any applicable law or regulation;</li>
            <li>6.1.3. you have no rights in, or to, the Platform or the technology used or supported by the Platform or any of the Services, other than the right to use each of them in accordance with these Terms of Use;</li>
            <li>6.1.4. you will not use the Platform or the Services in any manner inconsistent with these Terms of Use or Privacy Policy;</li>
            <li>6.1.5. you will not resell or make any commercial use of the Services or use the Services in any way that is unlawful, for any unlawful purpose, or in a manner that your use harms us, the Platform, or any other person or entity, as determined in our sole discretion, or act fraudulently or maliciously;</li>
            <li>6.1.6. you will not decipher, decompile, disassemble, reverse engineer or otherwise attempt to derive any hardware, or source code or underlying ideas or algorithms of any part of the Service;</li>
            <li>6.1.7. you will not transmit or make available any software or other computer files that contain a virus or other harmful component;</li>
            <li>6.1.8. you will not post, publish or transmit any content or messages that are false, misleading, defamatory, harmful, threatening, abusive or constitute harassment;</li>
            <li>6.1.9. you will not promote the use of explosives or firearms, the consumption of psychotropic drugs or any other illegal activities;</li>
            <li>6.1.10. you will not disparage, make false or malicious statements against us or in connection with the Services or the Platform;</li>
            <li>6.1.11. you will not interfere or attempt to interfere with the proper working of the Platform;</li>
            <li>6.1.12. you will not bypass any measures we may use to prevent or restrict access to the Services;</li>
            <li>6.1.13. you will not run any form of autoresponder or "spam" on the Platform;</li>
            <li>6.1.14. you will not use manual or automated software, devices, or other processes to "crawl" or "spider" any part of the Services;</li>
            <li>6.1.15. you will not modify, adapt, appropriate, reproduce, distribute, translate, create derivative works or adaptations of, publicly display, republish, repurpose, sell, trade, or in any way exploit the Service;</li>
            <li>6.1.16. you will not delete or modify any content of the Services, including but not limited to, legal notices, disclaimers or proprietary notices.</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>7. Payment Terms</h2>
          <p>
            You hereby acknowledge and agree that in order to avail our services, you explicitly agree to pay the fees in a manner and mode, as notified to you by us. The said fee is subject to a periodic review and may be revised at our sole discretion and such revisions may be intimated to you as and when required. Please note that your network operator may also separately charge you for data and other usage.
          </p>
        </section>

        <section className="legal-section">
          <h2>8. Conditions to Use</h2>
          <p>
            8.1. The Services will be provided on a best-efforts basis. We will make reasonable efforts and shall endeavor that you are able to use the Services without undue disruption, interruption or delay.
          </p>
          <p>
            8.2. Once you login on the Platform, you may receive updates, promotional materials and other information we may send with regards to the Service. You may opt out by writing to us at care@amatya.co.in.
          </p>
          <p>
            8.3. We disclaim any responsibility for any harm resulting from anyone's use of or access to the Services. You are responsible for taking precautions as necessary to protect yourself and your device(s) from malware, viruses, and other harmful software.
          </p>
        </section>

        <section className="legal-section">
          <h2>9. Intellectual Property</h2>
          <p>
            9.1. You agree and acknowledge that we are and we will remain the owner of the Platform and the Services thereunder at all times. All content including features, functionality, software, design, text, sound recordings and images are our exclusive property.
          </p>
          <p>
            9.2. All trademarks, service marks, trade names, trade dress, and other forms of intellectual property are proprietary to us. No content may be copied, reproduced, republished, uploaded, posted, transmitted or distributed without our express written permission.
          </p>
        </section>

        <section className="legal-section">
          <h2>10. Third-Party Links</h2>
          <p>
            The Platform includes links to third-party websites and/or applications. When you access a third-party link that leaves the Platform, you acknowledge that the website or application you enter into is not controlled by the Company and different terms of use and privacy policies may apply.
          </p>
        </section>

        <section className="legal-section">
          <h2>11. Indemnity and Limitation of Liability</h2>
          <p>
            11.1. To the extent permitted by law, you agree to indemnify the Company, its officers, directors and employees from and against any losses, damages, costs, expenses and claims arising out of your use of the Services, any breach of these Terms of Use, or your breach of any applicable laws.
          </p>
          <p>
            11.2. To the fullest extent permitted by law, in no event will the Company be liable for any direct, indirect, special, incidental, punitive, exemplary or consequential damages.
          </p>
        </section>

        <section className="legal-section">
          <h2>12. Termination</h2>
          <p>
            12.1. We may terminate your access to all or any part of the Service at any time, with or without cause, with or without notice, effective immediately.
          </p>
          <p>
            12.2. We reserve the right to cease operating the Platform or any of the Services at any time without notice.
          </p>
        </section>

        <section className="legal-section">
          <h2>13. Disclaimer</h2>
          <p>
            13.1. The Services provided on the Platform are solely in relation to the Sanatana Dharma. This restriction is in no manner discriminatory towards other religions or religious practices.
          </p>
          <p>
            13.2. We do not represent or warrant the reality or reliability of the astrological effects on human physiology or any other products or services. We do not provide any medical advice.
          </p>
          <p>
            13.3. The advisors/consultants/astrologers are not employees of the Platform and are third party service providers. You connect with them at your own risk.
          </p>
          <p>
            13.4. The Services are provided on an "as is" basis. We do not guarantee accuracy, adequacy, correctness, validity, completeness, or suitability for any purpose.
          </p>
          <p>
            13.5. AMATYA acts as a service provider. Payments made to AMATYA are not eligible for 80G tax deductions.
          </p>
        </section>

        <section className="legal-section">
          <h2>14. Governing Law</h2>
          <p>
            These Terms of Use shall be governed by and construed in accordance with the laws of India. You consent to the exclusive jurisdiction of the courts located in New Delhi, India.
          </p>
        </section>

        <section className="legal-section">
          <h2>15. Severability</h2>
          <p>
            If any provision of these Terms of Use is found to be unenforceable or invalid, that provision will be limited or eliminated to the minimum extent necessary so that these Terms of Use will otherwise remain in full force and effect.
          </p>
        </section>

        <section className="legal-section">
          <h2>16. Modification of Terms of Use</h2>
          <p>
            We reserve the right, at our sole discretion, to modify or replace any of these Terms of Use, or change, suspend, or discontinue the Services at any time. Your continued use of the Services following any changes constitutes acceptance of those changes.
          </p>
        </section>

        <section className="legal-section">
          <h2>17. Miscellaneous</h2>
          <p>
            17.1. Unless otherwise specified, all notices will be in writing and will be deemed to have been duly given when received or when receipt is electronically confirmed.
          </p>
          <p>
            17.2. Nothing in these Terms of Use shall be deemed to grant any rights or benefits to any person other than us and you.
          </p>
        </section>

        <section className="legal-section">
          <h2>18. Contact</h2>
          <p>
            In the event that you wish to raise a query or complaint with us, please contact our Grievance Officer:
          </p>
          <div className="legal-contact">
            <p><strong>Name:</strong> Mr. Sumitt Saini</p>
            <p><strong>Designation:</strong> CEO</p>
            <p><strong>Contact Number:</strong> +91 9711767167</p>
            <p><strong>Email ID:</strong> care@amatya.co.in</p>
          </div>
        </section>

        <div className="legal-footer-note">
          <p>
            <strong>YOU HAVE FULLY READ AND UNDERSTOOD THESE TERMS OF USE AND VOLUNTARILY AGREE TO ALL OF THE PROVISIONS CONTAINED ABOVE</strong>
          </p>
          <p>Last updated on 5th March 2026</p>
          <p>ANS LEGAL AND BUSINESS SERVICES LLP</p>
          <p>care@amatya.co.in</p>
        </div>
      </div>
    </div>
  );
};

export default TermsOfUsePage;
